const MuiListItemText = () => ({
  root: {
    "& span": {
      display: "inline",
    },
  },
});

export default MuiListItemText;
